
import React, { useState, useRef } from "react";
import { MdDeleteForever } from "react-icons/md";
import "./Input.css";
import "./Button.css";
import AlertToast from "./AlertToast";

function Input() {
  const [numero, setNumero] = useState("");
  const [textoBoton, setTextoBoton] = useState("Escanear codigos de barra");
  const [resplandor, setResplandor] = useState(false);
  const [sampleRows, setSampleRows] = useState([]);

  const alertToastRef = useRef(null);

  function addRowFromResponse(record, barcode) {
    const row = {
      id: record.data.sample.id.toUpperCase(),
      destination: record.data.destination.name,
      name: record.data.sample.name || '',
      heading: record.data.additionalHeading
        ? ' - ' + record.data.additionalHeading
        : '',
    };
  
    setSampleRows((prevRows) => [row, ...prevRows]);
  }

  const checkBrisaDestination = async (barcode) => {
    try {
      const url = `/api/sample/checkin?id=${encodeURIComponent(barcode)}`;
  
      const response = await fetch(url);
      const result = await response.json();
  
      if (response.ok && result?.data) {
        addRowFromResponse(result, barcode);
      } else {
        alertToastRef.current.showAlert({
          text: result.error || "Error from Brisa",
          bg: "danger",
        });
      }
    } catch (error) {
      console.error("Request error:", error);
      alertToastRef.current.showAlert({
        text: "Error al conectar con Brisa, Contactar a sistemas",
        bg: "danger",
      });
    }
  };

  const agregarCodigo = (codigo) => {
    if (codigo !== "") {
      if (codigo.length > 12) {
        alertToastRef.current.showAlert({
          text: "No puede tener más de 12 dígitos",
          bg: "danger",
        });
      } else {
        checkBrisaDestination(codigo)
      }
    }
  };
  
  const handleAgregarClick = () => {
    agregarCodigo(numero);
    setNumero("");
  };
  
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      agregarCodigo(numero);
      setNumero("");
    }
  };
  
  const handleClick = () => {
    if (!resplandor) {
      setTextoBoton("Detener");
      setResplandor(true);
      const inputElement = document.querySelector("input[type='text']");
      if (inputElement) {
        inputElement.focus();
      }
    } else {
      setTextoBoton("Escanear códigos de barra");
      setResplandor(false);
    }
  };

  const handleChange = (event) => {
    setNumero(event.target.value);
  };

  const handleBlur = () => {
    setTimeout(() => {
      setTextoBoton("Escanear códigos de barra");
      setResplandor(false);
    }, 500);
  };
  
  const filas = sampleRows.map((sample, index) => {
    const destination = sample.destination.toUpperCase();

    let backgroundColor = "#1d3557";

    if (destination.includes("CENTRALAB") || destination.includes("SIGUIENTE")) {
      backgroundColor = "#e63946";
    } else if (destination === "SIN PEDIDO") {
      backgroundColor = "lightgrey";
    }
    return (
      <tr key={index}>
        <td>
          <div style={{
                width: "",
                backgroundColor: backgroundColor,
                color: "white",
                padding: "10px",
                fontFamily:  "'Noto Sans', helvetica"
              }}
            >
            <div style={{
                  alignContent: "start",
                  fontSize: "22px",
                  fontWeight: "bold"
                }}  
              >
              {sample.id}&nbsp;&nbsp;
              { sample.destination.includes("CENTRALAB") || sample.destination.includes("SIGUIENTE") 
                  ? "CENTRALAB" 
                  : "MANLAB" 
              }
            </div>
            <div style={{color: "white", fontSize: "13px"}}>{sample.name}</div>
          </div>
        </td>
      </tr>
    )
  });

  return (
    <div className="mt-4">
      <AlertToast ref={alertToastRef} />
      <div className="d-flex justify-content-between mb-4">
        <button
          type="button"
          className={resplandor ? "btn btn-warning" : "btn btn-primary"}
          style={{
            color: resplandor ? "#000000" : "#ffffff",
            boxShadow: resplandor ? "0 0 10px 5px #ffc107" : "none",
            border: resplandor ? "1px solid grey" : "none",
            transition: "background-color 0.3s, box-shadow 0.3s",
          }}
          onClick={handleClick}
        >
          {textoBoton}
        </button>
        <input
          type="text"
          value={numero}
          onChange={handleChange}
          onBlur={handleBlur}
          onKeyDown={handleKeyDown}
          className="custom-input"
        />
      </div>
      <div className="input-group mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Agregar código manualmente"
          aria-label="Agregar código manualmente"
          aria-describedby="basic-addon2"
          value={numero}
          onChange={(e) => setNumero(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <div className="input-group-append">
          <button
            className="btn btn-primary"
            type="button"
            onClick={handleAgregarClick}
          >
            Agregar
          </button>
        </div>
      </div>

      <hr></hr>
      <div className="d-flex justify-content-center">
        <table style={{ width: "100%" }} className="table">
          <thead>
            <tr></tr>
          </thead>
          <tbody>{filas}</tbody>
        </table>
      </div>
    </div>
  );
}

export default Input;
